var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    staticClass: "root",
    class: {
      show: _vm.show
    },
    attrs: {
      "rounded": "",
      "text": "",
      "ripple": false,
      "color": _vm.color,
      "input-value": _vm.show
    }
  }, [_c('input', {
    ref: "search",
    attrs: {
      "type": "text",
      "disabled": !_vm.show
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function (e) {
        return _vm.$emit('input', e.target.value);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        _vm.show = !!_vm.value;
        _vm.$refs.search.blur();
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        $event.stopPropagation();
        _vm.show = !!_vm.value;
        _vm.$refs.search.blur();
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) return null;
        _vm.show = !!_vm.value;
      }],
      "blur": function (e) {
        var _e$relatedTarget;
        if (((_e$relatedTarget = e.relatedTarget) === null || _e$relatedTarget === void 0 ? void 0 : _e$relatedTarget.previousSibling) != e.target) _vm.show = !!_vm.value;
      },
      "!click": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('v-btn', {
    attrs: {
      "icon": "",
      "loading": _vm.loading,
      "color": _vm.color
    },
    on: {
      "click": function () {
        if (_vm.show && _vm.value) _vm.$emit('input', '');else _vm.show = !_vm.show;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.value ? _vm.mdiClose : _vm.mdiMagnify)
    }
  })], 1), _vm.tooltip && !_vm.show ? _c('span', {
    staticClass: "btn-tooltip bottom left"
  }, [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }